<template>
  <div>
    <Form ref="myForm" :label-width="95">
      <FormItem label="用户协议" prop="participation_notice">
        <tinymce v-model="content" :height="600"></tinymce>
      </FormItem>
      <Button type="primary" @click="submit" :loading="loading" style="margin-left: 100px">提交</Button>
    </Form>
  </div>
</template>

<script>
import { getMemberProtocol, saveMemberProtocol } from '../../api/member'
import tinymce from '../../components/tinymce/index'
export default {
  name: 'member-protocol',
  components: { tinymce },
  data () {
    return {
      id: null,
      content: '',
      loading: false
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      getMemberProtocol({}).then(({ data }) => {
        this.id = data.id
        this.content = data.content
      }).finally(() => {

      })
    },
    submit () {
      this.loading = true
      saveMemberProtocol({ content: this.content, id: this.id }).then(() => {
        this.$Message.success('修改成功')
        this.fetchData()
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
